(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('porchroom-category-browser')) {
    customElements.define('porchroom-category-browser', class extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => this.setup());
      }
      setup() {
        if (!this.isConnected || !this.closest('.collection-page') || this.observer) return;
        this.navigation = this.querySelector('.catalog-nav');
        this.previous = this.querySelector('[data-category-previous]');
        this.next = this.querySelector('[data-category-next]');
        if (!this.navigation || !this.previous || !this.next) return;
        this.revealedCurrent = false;
        this.refresh = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
        };
        this.onClick = event => {
          const button = event.target.closest('[data-category-previous],[data-category-next]');
          if (!button || !this.contains(button) || button.getAttribute('aria-disabled') === 'true') return;
          const direction = getComputedStyle(this.navigation).direction === 'rtl' ? -1 : 1;
          this.navigation.scrollBy({
            left: (button === this.next ? 1 : -1) * direction * Math.max(120, this.navigation.clientWidth * .8),
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
          });
        };
        this.addEventListener('click', this.onClick);
        this.navigation.addEventListener('scroll', this.refresh, { passive: true });
        this.observer = new ResizeObserver(this.refresh);
        this.observer.observe(this);
        this.observer.observe(this.navigation);
        document.fonts?.ready.then(() => { if (this.isConnected) this.refresh(); });
        this.refresh();
      }
      update() {
        if (!this.isConnected) return;
        // Use the full available row, not the smaller scrollport between buttons.
        const overflow = matchMedia('(max-width:699px)').matches && this.navigation.scrollWidth > this.clientWidth + 1;
        if (overflow !== this.hasAttribute('data-overflow')) {
          const focusedButton = document.activeElement === this.previous || document.activeElement === this.next;
          if (!overflow && focusedButton) {
            (this.navigation.querySelector('[aria-current="page"]') || this.navigation.querySelector('a'))?.focus({ preventScroll: true });
          }
          if (!overflow) this.revealedCurrent = false;
          this.toggleAttribute('data-overflow', overflow);
          this.previous.hidden = !overflow;
          this.next.hidden = !overflow;
          this.refresh();
          return;
        }
        if (!overflow) return;
        if (!this.revealedCurrent) {
          const current = this.navigation.querySelector('[aria-current="page"]');
          if (current) {
            const bounds = this.navigation.getBoundingClientRect();
            const item = current.getBoundingClientRect();
            if (item.left < bounds.left) this.navigation.scrollLeft += item.left - bounds.left;
            else if (item.right > bounds.right) this.navigation.scrollLeft += item.right - bounds.right;
          }
          this.revealedCurrent = true;
        }
        const maximum = this.navigation.scrollWidth - this.navigation.clientWidth;
        const position = Math.min(maximum, Math.max(0, Math.abs(this.navigation.scrollLeft)));
        this.previous.setAttribute('aria-disabled', String(position <= 1));
        this.next.setAttribute('aria-disabled', String(position >= maximum - 1));
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.setupFrame);
        cancelAnimationFrame(this.frame);
        this.frame = 0;
        this.observer?.disconnect();
        this.observer = null;
        if (this.onClick) this.removeEventListener('click', this.onClick);
        if (this.refresh) this.navigation?.removeEventListener('scroll', this.refresh);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('porch-product-gallery')) {
    class PorchProductGallery extends HTMLElement {
      connectedCallback() {
        this.onDocumentReady = () => this.initialize();
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this.onDocumentReady, { once: true });
        } else {
          this.initialize();
        }
      }

      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.onDocumentReady);
        cancelAnimationFrame(this.initialRevealFrame);
        this.thumbnailResizeObserver?.disconnect();
        this.events?.abort();
        this.initialized = false;
      }

      initialize() {
        if (this.initialized || !this.isConnected) return;
        const slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
        const thumbnails = Array.from(this.querySelectorAll('[data-gallery-thumbnail]'));
        const controls = this.querySelector('[data-gallery-controls]');
        const status = this.querySelector('[data-gallery-status]');
        const previous = this.querySelector('[data-gallery-prev]');
        const next = this.querySelector('[data-gallery-next]');
        const validSlides = slides.length > 0 && slides.every((slide, index) =>
          Number(slide.dataset.index) === index && slide.dataset.mediaId && slide.querySelector('img')
        );
        const validControls = slides.length === 1 || (
          controls && status && previous && next && thumbnails.length === slides.length &&
          thumbnails.every((thumbnail, index) => Number(thumbnail.dataset.index) === index)
        );
        if (!validSlides || !validControls) return;

        this.slides = slides;
        this.thumbnails = thumbnails;
        this.status = status;
        this.enlarge = this.querySelector('[data-gallery-enlarge]');
        this.events = new AbortController();
        this.addEventListener('click', (event) => {
          const control = event.target.closest('[data-gallery-thumbnail], [data-gallery-prev], [data-gallery-next]');
          if (!control || !this.contains(control)) return;
          let target = this.index;
          if (control.hasAttribute('data-gallery-thumbnail')) target = Number(control.dataset.index);
          if (control.hasAttribute('data-gallery-prev')) target -= 1;
          if (control.hasAttribute('data-gallery-next')) target += 1;
          this.showImage(target, true);
        }, { signal: this.events.signal });
        this.addEventListener('keydown', (event) => {
          const control = event.target.closest('[data-gallery-thumbnail], [data-gallery-prev], [data-gallery-next]');
          if (!control || !this.contains(control) || event.altKey || event.ctrlKey || event.metaKey) return;
          let target;
          if (event.key === 'ArrowLeft') target = this.index - 1;
          if (event.key === 'ArrowRight') target = this.index + 1;
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = this.slides.length - 1;
          if (target === undefined) return;
          event.preventDefault();
          this.showImage(target, true);
          if (control.hasAttribute('data-gallery-thumbnail')) {
            this.thumbnails[this.index]?.focus({ preventScroll: true });
          }
        }, { signal: this.events.signal });

        const initial = slides.findIndex((slide) => slide.hasAttribute('data-gallery-initial'));
        this.showImage(initial < 0 ? 0 : initial, false);
        this.setAttribute('data-gallery-enhanced', '');
        if (controls) controls.hidden = false;
        if (this.enlarge) this.enlarge.hidden = false;
        this.initialized = true;
        this.initialRevealFrame = requestAnimationFrame(() => {
          if (this.isConnected && this.initialized) this.revealThumbnail();
        });
        if (thumbnails.length && typeof ResizeObserver !== 'undefined') {
          this.thumbnailResizeObserver = new ResizeObserver(() => this.revealThumbnail());
          this.thumbnailResizeObserver.observe(thumbnails[0].parentElement);
        }
      }

      showImage(index, revealThumbnail) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, slideIndex) => {
          slide.hidden = slideIndex !== this.index;
        });
        this.thumbnails.forEach((thumbnail, thumbnailIndex) => {
          if (thumbnailIndex === this.index) thumbnail.setAttribute('aria-current', 'true');
          else thumbnail.removeAttribute('aria-current');
        });
        if (this.status) this.status.textContent = this.slides[this.index].dataset.counter || '';
        const imageLink = this.slides[this.index].querySelector('[data-gallery-image-link]');
        if (this.enlarge && imageLink) this.enlarge.href = imageLink.href;
        if (revealThumbnail) this.revealThumbnail();
      }

      revealThumbnail() {
        const thumbnail = this.thumbnails[this.index];
        if (thumbnail) {
          const strip = thumbnail.parentElement;
          const thumbnailBox = thumbnail.getBoundingClientRect();
          const stripBox = strip.getBoundingClientRect();
          if (thumbnailBox.left < stripBox.left) strip.scrollLeft -= stripBox.left - thumbnailBox.left;
          if (thumbnailBox.right > stripBox.right) strip.scrollLeft += thumbnailBox.right - stripBox.right;
        }
      }
    }

    customElements.define('porch-product-gallery', PorchProductGallery);
  }
  } catch(e) { console.error(e); }
})();

})();
